var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"bg-progress"},_vm._l((_vm.progress_list),function(item,i){return _c('bg-progress-item',{key:i,attrs:{"item":item,"last":i === _vm.progress_list.length - 1}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }